/** @format */
import { BotSettings } from '.././backendAccess/backendAccess';
import { getCookie } from '.././cookieHelper/cookieHelper';

//https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
export function makeid(length: number) {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const generateId = function (userId: string, botSettings: BotSettings) {
  // just use the userId, if it is already set
  if (userId != null && userId != '') return userId;

  // if the cookie contains the uid, take this
  if (
    botSettings != null &&
    botSettings.uidCookieName != null &&
    botSettings.uidCookieName != ''
  ) {
    var uid = getCookie(botSettings.uidCookieName);
    if (uid != null) return uid;
  }

  // otherwise, generate new id
  return makeid(20);
};
